document.addEventListener('DOMContentLoaded', function () {
    $('.custom_product_card .coupon_code .copy_btn').click(function () {
        navigator.clipboard.writeText($(this).parent().find('strong').text())
        $(this).text('✔');
        $(this).addClass('active');
        setTimeout(() => {
            $(this).text('COPY');
            $(this).removeClass('active');
        }, 3000);
    })

    $('.custom_product_card .buttons .nofify_btn').click(function (e) {
        e.preventDefault()
        $('.notify_dialog').removeClass('hide');
    });
    $('.custom_product_card .buttons .nofify_btn').click(function (e) {
        $('.notify_dialog .dialog_inner .close').click(function () {
            $('.notify_dialog').addClass('hide');
        });
    });
})